/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Obligation_To_PayInputs */

const en_checkout_obligation_to_pay = /** @type {(inputs: Checkout_Obligation_To_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By continuing, you are placing a binding order with an obligation to pay.`)
};

/**
* | output |
* | --- |
* | "By continuing, you are placing a binding order with an obligation to pay." |
*
* @param {Checkout_Obligation_To_PayInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_obligation_to_pay = /** @type {((inputs?: Checkout_Obligation_To_PayInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Obligation_To_PayInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_obligation_to_pay(inputs)
});